module.exports = __webpack_public_path__ + "img/manulife-banner-logo.8b67bd1b.svg";